import React from "react";
import { Redirect } from "react-router";
import "./Home.scss";

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = { trackingId: "", redirect: false };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({ trackingId: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState((state) => {
            return { ...state, redirect: true };
        });
    }

    shouldRedirect() {
        return this.state.redirect && this.state.trackingId !== "";
    }

    render() {
        if (this.shouldRedirect()) {
            const url = `/track/${this.state.trackingId}`;
            return <Redirect to={url} push />;
        }

        return (
            <div className="Home py-4 px-3 w-100 d-flex flex-column justify-content-center h-100 flex-grow-1">
                <div className="shadow content-card w-100">
                    <div className="bg-white rounded-top py-4 pt-md-5">
                        <img
                            src={require("../../assets/images/freight-people-logo-c.png")}
                            id="logo"
                            alt="Freight People"
                            className="fp-logo d-block mx-auto w-100"
                        />
                    </div>
                    <div
                        className="bg-primary rounded-bottom px-4 py-4 px-sm-5 pb-md-5 text-white
            text-center"
                    >
                        <p className="font-weight-bold mb-4 text-enter-tracking-no">Enter a tracking number</p>
                        <form
                            id="email-form"
                            name="email-form"
                            data-name="Email Form"
                            className="tracking-info w-100"
                            onSubmit={this.handleSubmit}
                        >
                            <div className="d-sm-flex align-items-stretch justify-content-center">
                                <input
                                    type="text"
                                    className="mx-auto form-control text-center text-uppercase
                    mb-4 mb-sm-0 mr-sm-3 input-tracking-no"
                                    maxLength="256"
                                    name="field"
                                    data-name="Field"
                                    placeholder="Tracking Number"
                                    id="field"
                                    required=""
                                    onChange={this.handleChange}
                                />
                                <button
                                    type="submit"
                                    className="mx-auto btn-form-submit btn btn-secondary text-uppercase px-4 py-2"
                                    data-wait="Please wait..."
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
